import { useCallback } from 'react'
import { LabeledValueType } from 'components/CIMSSelect/types'
import {
  normalizePermissionConditions,
  toSelectableLabeledValues,
} from '../../../utils'
import {
  PermissionFormValues,
  WorkflowPermissionField,
  WorkflowPermissionRecord,
  WorkflowPermissionStatus,
} from '../../../types'

export type UsePermissionFormValuesProps = {
  fieldMap: Map<string, WorkflowPermissionField>
  statusMap: Map<string, WorkflowPermissionStatus>
  toUserLabeledValues: (ids: string[]) => LabeledValueType[]
}

export function usePermissionFormValues({
  fieldMap,
  statusMap,
  toUserLabeledValues,
}: UsePermissionFormValuesProps) {
  return useCallback(
    (record: WorkflowPermissionRecord): PermissionFormValues => {
      const conditions = normalizePermissionConditions(record.conditions)
      return {
        action: record.action,
        approvalStatusId: conditions.approvalStatusId
          ? toSelectableLabeledValues(
              [conditions.approvalStatusId],
              statusMap,
              'status'
            )[0]
          : undefined,
        fieldIds: toSelectableLabeledValues(
          conditions.fieldIds,
          fieldMap,
          'field'
        ),
        statusIds: toSelectableLabeledValues(
          conditions.statusIds,
          statusMap,
          'status'
        ),
        users: toUserLabeledValues(record.users),
      }
    },
    [fieldMap, statusMap, toUserLabeledValues]
  )
}
